import e, { Component as o } from "react";
import t from "../../../../node_modules/classnames/index.js";
import n from "../../../utils/DomHandler.js";
import r from "../../../utils/ObjectUtils.js";
import { BodyCell as i } from "./BodyCell.js";
function a(e, o) {
  (null == o || o > e.length) && (o = e.length);
  for (var t = 0, n = Array(o); t < o; t++) n[t] = e[t];
  return n;
}
function s(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function p(e, o) {
  for (var t = 0; t < o.length; t++) {
    var n = o[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function l(e, o, t) {
  return o in e ? Object.defineProperty(e, o, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[o] = t, e;
}
function u(e) {
  return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function c(e, o) {
  return (c = Object.setPrototypeOf || function (e, o) {
    return e.__proto__ = o, e;
  })(e, o);
}
var d = function (o) {
  !function (e, o) {
    if ("function" != typeof o && null !== o) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(o && o.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), o && c(e, o);
  }(w, o);
  var d,
    f,
    h,
    g = (d = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        o,
        t = u(w);
      if (d) {
        var n = u(this).constructor;
        o = Reflect.construct(t, arguments, n);
      } else o = t.apply(this, arguments);
      return (e = o) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : s(this);
    });
  function w() {
    var e;
    return !function (e, o) {
      if (!(e instanceof o)) throw TypeError("Cannot call a class as a function");
    }(this, w), e = g.apply(this, arguments), l(s(e), "el", void 0), l(s(e), "state", {
      editing: e.props.editing
    }), l(s(e), "onClick", function (o) {
      e.props.onRowClick({
        originalEvent: o,
        data: e.props.rowData,
        index: e.props.index
      });
    }), l(s(e), "onDoubleClick", function (o) {
      e.props.onRowDoubleClick({
        originalEvent: o,
        data: e.props.rowData,
        index: e.props.index
      });
    }), l(s(e), "onRightClick", function (o) {
      e.props.onRowRightClick({
        originalEvent: o,
        data: e.props.rowData,
        index: e.props.index
      });
    }), l(s(e), "onTouchEnd", function () {
      e.props.onRowTouchEnd();
    }), l(s(e), "onKeyDown", function (o) {
      if (e.isFocusable() && !e.props.allowCellSelection) {
        var t = o.target,
          r = o.currentTarget;
        switch (o.which) {
          case 40:
            var i = e.findNextSelectableRow(r);
            i && (e.changeTabIndex(r, i), i.focus()), o.preventDefault();
            break;
          case 38:
            var a = e.findPrevSelectableRow(r);
            a && (e.changeTabIndex(r, a), a.focus()), o.preventDefault();
            break;
          case 13:
            n.isClickable(t) || (e.onClick(o), o.preventDefault());
            break;
          case 32:
            n.isClickable(t) || t.readOnly || (e.onClick(o), o.preventDefault());
        }
      }
    }), l(s(e), "onMouseDown", function (o) {
      e.props.onRowMouseDown({
        originalEvent: o,
        data: e.props.rowData,
        index: e.props.index
      });
    }), l(s(e), "onMouseUp", function (o) {
      e.props.onRowMouseUp({
        originalEvent: o,
        data: e.props.rowData,
        index: e.props.index
      });
    }), l(s(e), "onDragStart", function (o) {
      e.props.onRowDragStart({
        originalEvent: o,
        data: e.props.rowData,
        index: e.props.index
      });
    }), l(s(e), "onDragOver", function (o) {
      e.props.onRowDragOver({
        originalEvent: o,
        data: e.props.rowData,
        index: e.props.index
      });
    }), l(s(e), "onDragLeave", function (o) {
      e.props.onRowDragLeave({
        originalEvent: o
      });
    }), l(s(e), "onDragEnd", function (o) {
      e.props.onRowDragEnd({
        originalEvent: o,
        data: e.props.rowData,
        index: e.props.index
      });
    }), l(s(e), "onDrop", function (o) {
      e.props.onRowDrop({
        originalEvent: o,
        data: e.props.rowData,
        index: e.props.index
      });
    }), l(s(e), "onEditInit", function (o) {
      var t = o.originalEvent;
      e.props.onRowEditInit && e.props.onRowEditInit({
        originalEvent: t,
        data: e.props.rowData,
        index: e.props.index
      }), e.onEditChange(o, !0), t.preventDefault();
    }), l(s(e), "onEditSave", function (o) {
      var t = o.originalEvent,
        n = !e.props.rowEditValidator || e.props.rowEditValidator(e.props.rowData, {
          props: e.props.tableProps
        });
      e.props.onRowEditSave && e.props.onRowEditSave({
        originalEvent: t,
        data: e.props.rowData,
        index: e.props.index,
        valid: n
      }), n && (e.props.onRowEditComplete && e.props.onRowEditComplete(o), e.onEditChange(o, !1)), t.preventDefault();
    }), l(s(e), "onEditCancel", function (o) {
      var t = o.originalEvent;
      e.props.onRowEditCancel && e.props.onRowEditCancel({
        originalEvent: t,
        data: e.props.rowData,
        index: e.props.index
      }), e.onEditChange(o, !1), t.preventDefault();
    }), e;
  }
  return f = [{
    key: "isFocusable",
    value: function value() {
      return this.props.selectionMode && "single" !== this.props.selectionModeInColumn && "multiple" !== this.props.selectionModeInColumn;
    }
  }, {
    key: "isGrouped",
    value: function value(e) {
      return !!(this.props.groupRowsBy && this.getColumnProp(e, "field")) && (Array.isArray(this.props.groupRowsBy) ? this.props.groupRowsBy.indexOf(e.props.field) > -1 : this.props.groupRowsBy === e.props.field);
    }
  }, {
    key: "equals",
    value: function value(e, o) {
      return "equals" === this.props.compareSelectionBy ? e === o : r.equals(e, o, this.props.dataKey);
    }
  }, {
    key: "getColumnProp",
    value: function value(e, o) {
      return e ? e.props[o] : null;
    }
  }, {
    key: "getEditing",
    value: function value() {
      return this.props.onRowEditChange ? this.props.editing : this.state.editing;
    }
  }, {
    key: "getTabIndex",
    value: function value() {
      return this.isFocusable() && !this.props.allowCellSelection ? 0 === this.props.index ? this.props.tabIndex : -1 : null;
    }
  }, {
    key: "findIndex",
    value: function value(e, o) {
      var t = this;
      return (e || []).findIndex(function (e) {
        return t.equals(o, e);
      });
    }
  }, {
    key: "changeTabIndex",
    value: function value(e, o) {
      e && o && (e.tabIndex = -1, o.tabIndex = this.props.tabIndex);
    }
  }, {
    key: "findNextSelectableRow",
    value: function value(e) {
      var o = e.nextElementSibling;
      return o ? n.hasClass(o, "datatable__row--selectable") ? o : this.findNextSelectableRow(o) : null;
    }
  }, {
    key: "findPrevSelectableRow",
    value: function value(e) {
      var o = null == e ? void 0 : e.previousElementSibling;
      return o ? n.hasClass(o, "datatable__row--selectable") ? o : this.findPrevSelectableRow(o) : null;
    }
  }, {
    key: "shouldRenderBodyCell",
    value: function value(e, o, t) {
      if (this.getColumnProp(o, "hidden")) return !1;
      if (this.props.rowGroupMode && "rowspan" === this.props.rowGroupMode && this.isGrouped(o)) {
        var n = e[t - 1];
        if (n) return r.resolveFieldData(e[t], this.getColumnProp(o, "field")) !== r.resolveFieldData(n, this.getColumnProp(o, "field"));
      }
      return !0;
    }
  }, {
    key: "calculateRowGroupSize",
    value: function value(e, o, t) {
      if (!this.isGrouped(o)) return null;
      for (var n = r.resolveFieldData(e[t], this.getColumnProp(o, "field")), i = n, a = 0; n === i;) {
        a++;
        var s = e[++t];
        if (s) i = r.resolveFieldData(s, this.getColumnProp(o, "field"));else break;
      }
      return 1 === a ? null : a;
    }
  }, {
    key: "onEditChange",
    value: function value(e, o) {
      if (this.props.onRowEditChange) {
        var t,
          n = this.props.dataKey,
          i = e.originalEvent,
          s = e.data,
          p = e.index;
        if (n) {
          var u = String(r.resolveFieldData(s, n));
          (t = this.props.editingRows ? function (e) {
            for (var o = 1; o < arguments.length; o++) {
              var t = null != arguments[o] ? arguments[o] : {},
                n = Object.keys(t);
              "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function (e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
              }))), n.forEach(function (o) {
                l(e, o, t[o]);
              });
            }
            return e;
          }({}, this.props.editingRows) : {})[u] ? delete t[u] : t[u] = !0;
        } else if (this.props.editingRows instanceof Array) {
          var c,
            d = this.findIndex(this.props.editingRows, s);
          t = function (e) {
            if (Array.isArray(e)) return a(e);
          }(c = this.props.editingRows) || function (e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
          }(c) || function (e, o) {
            if (e) {
              if ("string" == typeof e) return a(e, o);
              var t = Object.prototype.toString.call(e).slice(8, -1);
              if ("Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t) return Array.from(t);
              if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return a(e, o);
            }
          }(c) || function () {
            throw TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }(), -1 !== d ? t.splice(d, 1) : t.push(s);
        }
        this.props.onRowEditChange({
          originalEvent: i,
          data: t,
          index: p
        });
      } else this.setState({
        editing: o
      });
    }
  }, {
    key: "renderContent",
    value: function value() {
      var o = this;
      return this.props.columns.map(function (t, n) {
        if (o.shouldRenderBodyCell(o.props.value, t, o.props.index)) {
          var r = "".concat(o.getColumnProp(t, "columnKey") || o.getColumnProp(t, "field"), "_").concat(n),
            a = "rowspan" === o.props.rowGroupMode ? o.calculateRowGroupSize(o.props.value, t, o.props.index) : null,
            s = o.getEditing();
          return e.createElement(i, {
            key: r,
            value: o.props.value,
            tableProps: o.props.tableProps,
            tableSelector: o.props.tableSelector,
            column: t,
            rowData: o.props.rowData,
            rowIndex: o.props.index,
            index: n,
            rowSpan: a,
            dataKey: o.props.dataKey,
            editing: s,
            editingMeta: o.props.editingMeta,
            editMode: o.props.editMode,
            onRowEditInit: o.onEditInit,
            onRowEditSave: o.onEditSave,
            onRowEditCancel: o.onEditCancel,
            onEditingMetaChange: o.props.onEditingMetaChange,
            onRowToggle: o.props.onRowToggle,
            selection: o.props.selection,
            allowCellSelection: o.props.allowCellSelection,
            compareSelectionBy: o.props.compareSelectionBy,
            selectOnEdit: o.props.selectOnEdit,
            selected: o.props.selected,
            onClick: o.props.onCellClick,
            onMouseDown: o.props.onCellMouseDown,
            onMouseUp: o.props.onCellMouseUp,
            tabIndex: o.props.tabIndex,
            cellClassName: o.props.cellClassName,
            responsiveLayout: o.props.responsiveLayout,
            frozenRow: o.props.frozenRow,
            showRowReorderElement: o.props.showRowReorderElement,
            onRadioChange: o.props.onRadioChange,
            onCheckboxChange: o.props.onCheckboxChange,
            expanded: o.props.expanded,
            expandedRowIcon: o.props.expandedRowIcon,
            collapsedRowIcon: o.props.collapsedRowIcon,
            virtualScrollerOptions: o.props.virtualScrollerOptions,
            selectable: o.props.selectable && !o.props.disabled
          });
        }
        return null;
      });
    }
  }, {
    key: "areColumnsEqual",
    value: function value(e, o) {
      if (e.length !== o.length) return !1;
      for (var t = 0; t < e.length; t++) if (!r.deepEquals(e[t].props, o[t].props)) return !1;
      return !0;
    }
  }, {
    key: "shouldComponentUpdate",
    value: function value(e, o) {
      var t = ["tableProps", "selection", "virtualScrollerOptions"],
        n = Object.keys(this.props),
        r = Object.keys(e),
        i = new Set(n.concat(r)),
        a = [];
      if (i.forEach(function (e) {
        a.push(e);
      }), this.state.editing !== o.editing) return !0;
      for (var s = 0; s < a.length; s++) {
        var p = a[s];
        if (!t.includes(p)) {
          if ("columns" === p) {
            if (!this.areColumnsEqual(this.props[p], e[p])) return !0;
            continue;
          }
          if (this.props[p] !== e[p]) return !0;
        }
      }
      return !1;
    }
  }, {
    key: "render",
    value: function value() {
      var o = this,
        n = t("datatable__row datatable__row--body", r.getPropValue(this.props.rowClassName, this.props.rowData, {
          props: this.props.tableProps
        }), {
          "datatable__row--selected": !this.props.allowCellSelection && this.props.selected,
          "datatable__row--context-menu-selected": this.props.contextMenuSelected,
          "datatable__row--selectable": this.props.allowRowSelection && !this.props.disabled && this.props.selectable,
          "datatable__row--odd": this.props.index % 2 != 0,
          "datatable__row--editing": this.getEditing(),
          "datatable__row--disabled": this.props.disabled
        }),
        i = this.renderContent(),
        a = this.getTabIndex();
      return e.createElement("tr", {
        ref: function ref(e) {
          return o.el = e;
        },
        role: "row",
        tabIndex: a,
        className: n,
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        onClick: this.onClick,
        onDoubleClick: this.onDoubleClick,
        onContextMenu: this.onRightClick,
        onTouchEnd: this.onTouchEnd,
        onKeyDown: this.onKeyDown,
        onDragStart: this.onDragStart,
        onDragOver: this.onDragOver,
        onDragLeave: this.onDragLeave,
        onDragEnd: this.onDragEnd,
        onDrop: this.onDrop
      }, i);
    }
  }], p(w.prototype, f), h && p(w, h), w;
}(o);
l(d, "defaultProps", {
  selectable: !0
});
export { d as BodyRow };